export interface LoginModalState {
  isLoginModalVisible: boolean
  isLoginSuccess: boolean
  redirectAfterLogin: boolean
  dealerMode: boolean
}
export const LOGIN_MODAL_NS = 'loginModal'
function getDefaultState(): LoginModalState {
  return {
    isLoginModalVisible: false,
    isLoginSuccess: false,
    redirectAfterLogin: true,
    dealerMode: false
  }
}
export default getDefaultState
